import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";

import * as actions from "../../../../store/actions";

import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Button, ColumnSelector, Spinner, ReactTable} from "../../../../components";

import i18n from "../../../../i18n";
import {apiGetCall} from "../../../../api";
import tableColumns from "../../../../variables/tableColumns";

class Coupler extends Component {
    state = {
        machines:        [],
        columns:         [],
        selectedMachine: null,
        loading:         true
    };

    tableColumns = tableColumns.machineColumnsDefaultCaretaker();

    constructor(props) {
        super(props);
        this.state.columns = this.tableColumns;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({loading: true, selectedMachine: null});
            apiGetCall("/machines/getmachinesforcoupling", {ignoreCaretaker: this.props.caretakerId})
                .then(res => {
                    this.setState({loading: false, machines: res.data.machines});
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    handleCouple = () => {
        if (this.props.redirect) {
            this.props.couple(this.state.selectedMachine, this.props.caretakerId, this.props.redirect);
        }
        else {
            this.props.couple(this.state.selectedMachine, this.props.caretakerId);
        }
        this.props.close();
    };

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.close} size="xl">
                <ModalHeader className="justify-content-center uppercase title" tag="h4">{i18n.machineCoupleTitle}</ModalHeader>
                <ModalBody>
                    <p>{i18n.machineCoupleBody.replace('%1', this.props.caretakerName)}</p>
                    <ColumnSelector cookieId="adminMachineCoupler" columns={this.state.columns} changed={columns => this.setState({columns})}/>
                    <ReactTable
                        filterable
                        defaultPageSize={5}
                        indexKey="id"
                        data={this.state.machines}
                        columns={this.state.columns}
                        noDataText={i18n.noMachines}
                        defaultSorted={[{id: "serial", desc: false}]}
                        defaultFiltered={[{id: "coupled", value: "No"}]}
                        getTrProps={(state, rowInfo) => {
                            if (rowInfo && rowInfo.row) {
                                let rowProps = {
                                    onClick: () => this.setState({selectedMachine: rowInfo.original.mac_address})
                                };
                                if (rowInfo.original.mac_address === this.state.selectedMachine) {
                                    rowProps.style = {
                                        background: rowInfo.original.mac_address === this.state.selectedMachine ? '#2CA8FF' : 'white',
                                        color:      rowInfo.original.mac_address === this.state.selectedMachine ? 'white' : 'black'
                                    }
                                }
                                return rowProps;
                            }
                            else {
                                return {}
                            }
                        }}
                    />
                    {this.state.loading && <Spinner/>}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" disabled={this.state.selectedMachine === null} onClick={this.handleCouple}>{i18n.machineCoupleSure}</Button>
                    <Button color="info" onClick={this.props.close}>{i18n.buttonCancel}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

Coupler.propTypes = {
    isOpen:        PropTypes.bool,
    close:         PropTypes.func.isRequired,
    caretakerName: PropTypes.string.isRequired,
    caretakerId:   PropTypes.string.isRequired,
    redirect:      PropTypes.string
};

const mapDispatchToProps = dispatch => ({
    couple: (macAddress, caretaker, redirect) => dispatch(actions.machines.couple(macAddress, caretaker, redirect))
});

export default connect(null, mapDispatchToProps)(Coupler);